export default __webpack_public_path__ + "static/media/plant3b.056f0d07.png";